const otherService = {
    name: '其他增值服务',
    code:'',
    children: [
        {
            name: '委托收件',
            code:'IN10'
        },
        {
            name: '特殊入仓',
            code:'IN02'
        },
        {
            name: '送货上楼',
            code:'IN145'
        },
        {
            name: '安装服务',
            code:'IN103'
        },
        {
            name: '电子验收',
            code:'IN91'
        },               
        {
            name: '保单配送',
            code:'IN87'
        },
        {
            name: '票据专送',
            code:'IN99'
        },
        {
            name: '验货服务',
            code:'IN52'
        },
        {
            name: '超长超重服务',
            code:'IN23'
        },
        {
            name: '送货服务',
            code:'IN74'
        },
        {
            name: '提货服务',
            code:'IN73'
        },               
        {
            name: '装卸服务',
            code:'IN65'
        },
        {
            name: '大件入户',
            code:'IN98'
        },
        {
            name: '春节服务费',
            code:'IN106'
        },
        {
            name: '燃油附加费',
            code:'IN15'
        },
        {
            name: '住宅附加费',
            code:'IN38'
        },
        {
            name: '更改付款方式',
            code:'IN86'
        },
        {
            name: '货物保管',
            code:'IN46'
        },
        {
            name: '国际偏远附加费',
            code:'IN16'
        },
    ]
}

const ServiceRouter = {
    name: '增值服务',
    code:'',
    children: [
        {
            name: '普通保价',
            code: 'IN02'
        },
        {
            name: '特安服务',
            code: 'IN21'
        },
        {
            name: '代收货款',
            code: 'IN01'
        },
        {
            name: '签单返还',
            code:'IN56'
        },
        {
            name: '包装服务',
            code:'IN67'
        },
        {
            name: '保鲜服务',
            code:'IN41'
        },
        {
            name: '定时派送',
            code:'IN26'
        },
        {
            name: '口令签收',
            code:'IN59'
        },
        {
            name: '原单转寄退回',
            code:'IN88'
        },
        otherService,
    ],
}

export default ServiceRouter


// WEBPACK FOOTER //
// ./src/components/header/menuConfig/service.js